<template>
    <ActionDropdown :actions="actions" cssClass="ms-1" />
    <ProfileModal :application="application" ref="ProfileModal" @created="$emit('created', $event)" />
    <ProfileImportModal ref="ProfileImportModal" @updated="$emit('updated', $event)" :application="application" />
    <ImportModal ref="ImportModal" @created="$emit('created', $event)"
        :endpoint="`applications/${this.application.id}/profiles/import-excel`" :name="i18n('Profiles')" :columns="[
      'name',
      'profile_type',
      'permissions',      
    ]">
    </ImportModal>

</template>

<script>
import api from "@/api.js";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import ProfileModal from "@/components/profile/ProfileModal.vue";
import ProfileImportModal from "@/components/profile/ProfileImportModal.vue";
import ImportModal from "@/components/common/import/ImportModal.vue";

export default {
    components: {
        ActionDropdown,
        ProfileModal,
        ProfileImportModal,
        ImportModal,
    },
    props: {
        application: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            permissions: [],
            filters: {},
            loadTimeout: null,
            loading: true,
        }
    },
    emits: [
        'updated',
        'created',
        'shown',
        'hidden',
        'submit',
    ],
    watch: {
    },
    methods: {
        showProfileModal() {
            if (!this.$refs['ProfileModal']) return;
            this.$refs['ProfileModal'].show();
        },
        showProfileImportModal() {
            if (!this.$refs['ProfileImportModal']) return;
            this.$refs['ProfileImportModal'].show();
        },
    },
    computed: {
        actions() {
            return [
                {
                    label: this.i18n('Add New'),
                    fn: () => {
                        this.showProfileModal();
                    },
                    if: this.application?.acl?.update === true,
                    starred: true,
                },
                {
                    label: this.i18n('Export profiles Json'),
                    fn: () => {
                        api.getFile(`applications/${this.application.id}/profiles/export`, {}, 'export_profiles_' + this.application.name + '.json').then(result => {
                            api.clearCache();
                        }).catch((err) => {
                            this.$root.showErrorModal(this.i18n('Error'), this.i18n('Document could not be downloaded. Try again later.'));
                        });
                    },
                    if: this.application?.acl?.export === true,
                },
                {
                    label: this.i18n('Export profiles Excel'),
                    fn: () => {
                        api.getFile(`applications/${this.application.id}/profiles/export-excel`, {}, 'export_profiles_' + this.application.name + '.xlsx').then(result => {
                            api.clearCache();
                        }).catch((err) => {
                            this.$root.showErrorModal(this.i18n('Error'), this.i18n('Document could not be downloaded. Try again later.'));
                        });
                    },
                    if: this.application?.acl?.export === true && this.$root?.features?.profiles?.import_export_excel,
                },
                {
                    label: this.i18n('Import Profiles Json'),
                    fn: () => {
                        this.showProfileImportModal();
                    },
                    if: this.application?.acl?.import === true,
                },
                {
                    label: this.i18n('Import profiles Excel'),
                    fn: () => {
                        this.$refs['ImportModal'].show();
                    },
                    if: this.application?.acl?.import === true && this.$root?.features?.profiles?.import_export_excel,
                },
            ];
        },
    },
};
</script>